import { Outlet } from "react-router-dom";
import { useState, useEffect } from "react";
import LabsNavbar from "../components/LabsNavbar";
import { PortalRootProvider } from "../contexts/PortalRootContext";

function LabsPage() {
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const [portalRoot, setPortalRoot] = useState<HTMLElement | null>(null); // State to hold the dynamically created portal root

  useEffect(() => {
    // Create a div element to serve as the portal root
    const el = document.createElement('div');
    el.id = 'labs-portal-root'; // Give it a unique ID for identification
    el.style.position = 'absolute'; // Position it absolutely
    el.style.top = '0';
    el.style.left = '0';
    el.style.width = '100%';
    el.style.height = '100%';
    el.style.pointerEvents = 'none'; // Allow clicks to pass through
    el.style.zIndex = '9999'; // Ensure it's on top of everything

    document.body.appendChild(el); // Append it to the body
    setPortalRoot(el); // Set it in state

    // Cleanup function to remove the div when the component unmounts
    return () => {
      document.body.removeChild(el);
    };
  }, []); // Run once on mount and cleanup on unmount

  return (
    <div className="flex h-screen bg-gray-50 dark:bg-gray-900">
      <LabsNavbar isMobileNavOpen={isMobileNavOpen} setMobileNavOpen={setMobileNavOpen} />
      <div className="flex-1 overflow-y-auto">
        {/* The Outlet and its children will now receive the portalRoot from context */}
        <PortalRootProvider portalRoot={portalRoot}>
          <Outlet />
        </PortalRootProvider>
      </div>
    </div>
  );
}

export default LabsPage;
